"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("../utils");

var ColorConverter_1 = require("./ColorConverter");

var StyleConverter =
/** @class */
function () {
  function StyleConverter() {}

  StyleConverter.prototype.fromMessage = function (message) {
    var object = {};
    if (utils_1.hasValue(message.accentColor)) object.accentColor = ColorConverter_1.colorConverter.fromMessage(message.accentColor);
    if (utils_1.hasValue(message.backgroundColor)) object.backgroundColor = ColorConverter_1.colorConverter.fromMessage(message.backgroundColor);
    if (utils_1.hasValue(message.foregroundColor)) object.foregroundColor = ColorConverter_1.colorConverter.fromMessage(message.foregroundColor);
    if (utils_1.hasValue(message.highlightColor)) object.highlightColor = ColorConverter_1.colorConverter.fromMessage(message.highlightColor);
    if (utils_1.hasValue(message.shadowColor)) object.shadowColor = ColorConverter_1.colorConverter.fromMessage(message.shadowColor);
    return object;
  };

  StyleConverter.prototype.toMessage = function (object) {
    var message = {};
    if (utils_1.hasValue(object.accentColor)) message.accentColor = ColorConverter_1.colorConverter.fromMessage(object.accentColor);
    if (utils_1.hasValue(object.backgroundColor)) message.backgroundColor = ColorConverter_1.colorConverter.fromMessage(object.backgroundColor);
    if (utils_1.hasValue(object.foregroundColor)) message.foregroundColor = ColorConverter_1.colorConverter.fromMessage(object.foregroundColor);
    if (utils_1.hasValue(object.highlightColor)) message.highlightColor = ColorConverter_1.colorConverter.fromMessage(object.highlightColor);
    if (utils_1.hasValue(object.shadowColor)) message.shadowColor = ColorConverter_1.colorConverter.fromMessage(object.shadowColor);
    return message;
  };

  return StyleConverter;
}();

exports.StyleConverter = StyleConverter;
exports.styleConverter = new StyleConverter();